module.exports = "<select ng-model=vm.selectedOperator ng-options=\"operator.value as operator.name for operator in vm.operators\"> </select>";